import { render, staticRenderFns } from "./PageReportView.vue?vue&type=template&id=5a128674&"
import script from "./PageReportView.vue?vue&type=script&lang=js&"
export * from "./PageReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports